import styled from 'styled-components';

export const PercentileCard = styled.div`
  background: white;
  border-radius: 8px;
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  border: 1px solid oklch(0.838 0.014 312);
`;

export const PercentileLabel = styled.div`
  font-size: 16px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(128, 128, 128);
  letter-spacing: 0.5px;
  margin-bottom: 4px;
`;

export const PercentileValue = styled.div`
  font-size: 28px;
  font-family: Calibre-Semibold, sans-serif;
  color: rgb(26, 23, 28);
  line-height: 1.2;
  margin-bottom: 4px;
`;

export const PercentileRecommendation = styled.div`
  font-size: 12px;
  font-family: Calibre-Regular, sans-serif;
  color: rgb(80, 80, 80);
  line-height: 1.3;
  min-height: 16px;
`;
